var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgR(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "R",
    transform: "translate(13395 17163)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4022",
    "data-name": "Rectangle 4022",
    width: 60,
    height: 60,
    transform: "translate(-13395 -17163)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13323",
    "data-name": "Group 13323",
    transform: "translate(-285.02 -60.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6405",
    "data-name": "Path 6405",
    d: "M62.541,47.781H44.895a2.121,2.121,0,0,1-2.1-2.122V27.906a1.369,1.369,0,0,0-1.343-1.343A22.426,22.426,0,0,0,19.029,49.635a22.724,22.724,0,0,0,21.783,21.81h.645A22.456,22.456,0,0,0,63.884,49.018a1.344,1.344,0,0,0-1.343-1.236Zm-7.332,15.5a19.663,19.663,0,0,1-14.316,5.587A19.988,19.988,0,0,1,21.715,49.688a19.771,19.771,0,0,1,18.4-20.279V45.524a4.806,4.806,0,0,0,4.781,4.808H61.01a19.518,19.518,0,0,1-5.8,12.946Z",
    transform: "translate(-13124 -17118.863)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6406",
    "data-name": "Path 6406",
    d: "M51.624,21.094a1.343,1.343,0,0,0-1.343,1.343V39.949A4.913,4.913,0,0,0,55.2,44.864H72.709a1.341,1.341,0,0,0,1.343-1.343A22.456,22.456,0,0,0,51.625,21.094ZM55.2,42.178a2.228,2.228,0,0,1-2.229-2.229V23.833A19.735,19.735,0,0,1,71.312,42.178Z",
    transform: "translate(-13128.392 -17118.094)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR);
export default __webpack_public_path__ + "static/media/R.4c3c564340b6820e0b646ebef80d0983.svg";
export { ForwardRef as ReactComponent };